import React, { useEffect, useState } from 'react';
import { Card, CardContent, Tabs, Tab, Box } from '@material-ui/core';
import { FuseAnimate } from '@fuse';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { reg, isTrainingEnabled } from '@config';
import LoginTab from './LoginTab';
import TrainingSessionTab from './TrainingSessionTab';
import BrandingPanel from './BrandingPanel';

import { useLocation, useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundImage: 'url("assets/images/backgrounds/dark-material-bg.jpg")',
		color: theme.palette.primary.contrastText,
		'background-size': 'cover',
	},
}));

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<div>{children}</div>
				</Box>
			)}
		</div>
	);
}

const Login = (props) => {
	const classes = useStyles();
	const location = useLocation();
	const history = useHistory();

	const isTrainingRoute = location.pathname.includes('/training');
	const defaultTabIndex = isTrainingRoute ? 1 : 0;
	const [value, setValue] = useState(defaultTabIndex);
	const [recoverPassword, setRecoverPassword] = useState(false);
	const [showTraining, setShowTraining] = useState(false);

	useEffect(() => {
		const getTraining = async () => {
			const training = await isTrainingEnabled();
			setShowTraining(training);
		};
		getTraining();
	}, []);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		if (isTrainingRoute && newValue === 0) {
			history.push('/login');
		}
	};

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-1 flex-shrink-0 p-24 md:flex-row md:p-0 overflow-x-hidden')}>
			<BrandingPanel />

			<FuseAnimate animation={{ translateX: [0, '100%'] }}>
				<Card className="mt-64 mb-64 min-w-400 mr-64">
					{!isTrainingRoute && (
						<Tabs value={value} onChange={handleChange} aria-label="login tabs" variant="fullWidth">
							<Tab label="Sign-In" key="signin" />
							<Tab label="Workshops" key="workshops" />
						</Tabs>
					)}
					<CardContent className="flex flex-col items-center justify-center md:pt-64 w-full pl-0 pr-0">
						<TabPanel value={value} index={0}>
							<LoginTab props={props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} reg={reg} />
						</TabPanel>
						<TabPanel value={value} index={1}>
							<TrainingSessionTab props={props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} />
						</TabPanel>
					</CardContent>
				</Card>
			</FuseAnimate>
		</div>
	);
};

export default Login;

